import {
    SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED,
    SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS,
    SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED,
    SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS
} from "./CustomerConstants";


export const searchCustomerByCodeRequestSuccess = (customers) => {
    return {
        type: SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS,
        payload: customers
    }
}


export const searchCustomerByCodeRequestFailed = (error) => {
    return {
        type: SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED,
        payload: error
    }
}


export const searchCustomerByNameRequestSuccess = (customers) => {
    return {
        type: SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS,
        payload: customers
    }
}


export const searchCustomerByNameRequestFailed = (error) => {
    return {
        type: SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED,
        payload: error
    }
}
